module.exports = __webpack_public_path__ + "static/fonts/fa-solid-900.6661d6b.woff";


//////////////////
// WEBPACK FOOTER
// ./src/assets/webfonts/fa-solid-900.woff
// module id = oLdV
// module chunks = 0